interface UpdateDetails {
  [key: string]: any;
}

export interface InstallationErrorDetails {
  operationId: string;
  startedAt?: string;
  error: Record<string, any>;
}

// the ota firmware processes all run the folder structure check
// but only one of the other (sftp_push, sftp_backup) will actually run
// so we can just iterate over the phases and return the first error we find
const ERROR_PHASES = ["folder_structure", "sftp_push", "sftp_backup"] as const;

const isNonEmptyObject = (value: any): boolean =>
  Boolean(value) && typeof value === "object" && Object.keys(value).length > 0;

export const getInstallationErrorDetails = (
  updateDetails: UpdateDetails = {},
): InstallationErrorDetails | null => {
  for (const phase of ERROR_PHASES) {
    const operationId = updateDetails[`${phase}_operation_id`];
    const error = updateDetails[`${phase}_error`];

    if (operationId && isNonEmptyObject(error)) {
      return {
        operationId,
        startedAt: updateDetails[`${phase}_started_at`],
        error,
      };
    }
  }

  return null;
};
